import { Helmet } from "react-helmet-async";

const SITE = "https://brazierdevelopments.com.au";
const DEFAULT_IMAGE =
    "https://customer-assets.emergentagent.com/job_web-project-300/artifacts/e8ag2s51_CoverNAV4.jpg";

export const Seo = ({ title, description, path = "/", image, type = "website", jsonLd }) => {
    const url = `${SITE}${path}`;
    const img = image || DEFAULT_IMAGE;
    const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={img} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={img} />
            {schemas.map((s, i) => (
                <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
            ))}
        </Helmet>
    );
};
